import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'age',
})
export class AgePipe implements PipeTransform {
  transform(value: Date): string {
    const today = new Date();
    const birthdate = new Date(value);
    let years = today.getFullYear() - birthdate.getFullYear();
    const m = today.getMonth() - birthdate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
      years--;
    }
    return years <= 0 ? 'Less than 1 yr' : years + ' yr';
  }
}
